Postlogin = (function (my) {
    my.Lesson = (function (self) {
        self.Bingo = function (segmentData) {
            const me = Postlogin.Lesson.Segment(segmentData);
            me.play_pause_enabled = false;

            const containerId = `${me.activity_type}-container-${me.segment_index}`;
            let container;
            const numberOfOptions = Object.keys(me.options).length;
            let numberMatched = 0;
            let threeInARow = false;
            let keepPlaying = false;

            const correctSets = [
                [1, 2, 3],
                [4, 5, 6],
                [7, 8, 9],
                [1, 4, 7],
                [2, 5, 8],
                [3, 6, 9],
                [1, 5, 9],
                [3, 5, 7],
            ];

            const correctSets4x4 = [
                [1, 2, 3, 4],
                [5, 6, 7, 8],
                [9, 10, 11, 12],
                [13, 14, 15, 16],

                [1, 5, 9, 13],
                [2, 6, 10, 14],
                [3, 7, 11, 15],
                [4, 8, 12, 16],

                [1, 6, 11, 16],
                [4, 7, 10, 13],
            ];

            const answerIds = [];
            let currentOptionId = null;

            me.init = function () {
                if (me.activity_data.instructions) {
                    me.help_enabled = true;
                }
                me.renderSegment();
            };

            me.renderSegment = function () {
                container = me.renderSegmentContainer();
                const segmentContainer = $('<div></div>')
                    .addClass(`${me.activity_type}-container segment-content-container`)
                    .attr('id', containerId);

                // set the number of options (used in css for displaying options)
                segmentContainer.attr('data-options-count', numberOfOptions);

                const bingoBoard = $('<div></div>').addClass('bingo-board');
                bingoBoard.css('backgroundImage', `url(${me.activity_data.instructions_image})`);
                if (numberOfOptions === 16) {
                    bingoBoard.addClass('four-by-four');
                }

                const cluesContainer = $('<div></div>').addClass('clues-container');
                cluesContainer.append('<h2 class="cartoony">Bingo Clue:</h2>');

                const clues = $('<div></div>').addClass('clues');
                let index = 1;

                $.each(me.options, (i, option) => {
                    const bingoAnswer = $('<div></div>').addClass(`bingo-answer item option-${i}`);
                    bingoAnswer.attr('data-option-id', option.activity_option_id);
                    bingoAnswer.attr('data-index', index);

                    const wrapper = $('<div></div>').addClass('wrapper');
                    if (option.answer_image) {
                        bingoAnswer.addClass('has-image');
                        wrapper.css('backgroundImage', `url(${option.answer_image})`);
                        if (option.answer) {
                            wrapper.append(`<div class="option-text"><span>${option.answer}</span></div>`);
                        }
                    } else {
                        bingoAnswer.addClass('text-only');
                        if (option.answer) {
                            wrapper.append(`<div class="option-text"><span>${option.answer}</span></div>`);
                        }
                    }

                    bingoAnswer.append(wrapper);

                    bingoAnswer.on('click', function () {
                        const $answer = $(this);
                        if ($answer.hasClass('correct') || $answer.hasClass('incorrect')) {
                            return;
                        }
                        const optionId = $(this).attr('data-option-id');
                        const answerIndex = +answerIds[$(this).attr('data-index')];
                        if (+optionId === +currentOptionId) {
                            // play the 'correct' sound
                            self.playSoundEffect('correct');

                            // mark the answer as correct
                            $answer.addClass('correct');

                            // mark the clue as matched
                            const $oldClue = $(`.bingo-clue[data-option-id="${optionId}"]`);

                            $oldClue.addClass('animated zoomOutLeft');
                            setTimeout(() => {
                                $oldClue.removeClass('active').addClass('matched');
                            }, 500);

                            numberMatched++;

                            if (numberOfOptions === 9) {
                                if (numberMatched >= 3) {
                                    $(correctSets).each((key, set) => {
                                        const answer1 = $(container).find(`.bingo-board > .bingo-answer:nth-child(${set[0]})`);
                                        const answer2 = $(container).find(`.bingo-board > .bingo-answer:nth-child(${set[1]})`);
                                        const answer3 = $(container).find(`.bingo-board > .bingo-answer:nth-child(${set[2]})`);
                                        if (
                                            $(answer1).hasClass('correct')
                                            && $(answer2).hasClass('correct')
                                            && $(answer3).hasClass('correct')
                                            && (answerIndex === +set[0] || answerIndex === +set[1] || answerIndex === +set[2])
                                        ) {
                                            threeInARow = true;
                                            answer1.addClass('animated tada three-in-a-row');
                                            answer2.addClass('animated tada three-in-a-row middle');
                                            answer3.addClass('animated tada three-in-a-row');
                                            setTimeout(() => {
                                                answer1.removeClass('animated tada three-in-a-row');
                                                answer2.removeClass('animated tada three-in-a-row middle');
                                                answer3.removeClass('animated tada three-in-a-row');
                                            }, 1000);
                                        }
                                    });
                                }
                            } else if (numberMatched >= 4) {
                                $(correctSets4x4).each((key, set) => {
                                    const answer1 = $(container).find(`.bingo-board > .bingo-answer:nth-child(${set[0]})`);
                                    const answer2 = $(container).find(`.bingo-board > .bingo-answer:nth-child(${set[1]})`);
                                    const answer3 = $(container).find(`.bingo-board > .bingo-answer:nth-child(${set[2]})`);
                                    const answer4 = $(container).find(`.bingo-board > .bingo-answer:nth-child(${set[3]})`);
                                    if (
                                        $(answer1).hasClass('correct')
                                        && $(answer2).hasClass('correct')
                                        && $(answer3).hasClass('correct')
                                        && $(answer4).hasClass('correct')
                                        && (answerIndex === +set[0]
                                            || answerIndex === +set[1]
                                            || answerIndex === +set[2]
                                            || answerIndex === +set[3])
                                    ) {
                                        threeInARow = true;
                                        answer1.addClass('animated tada three-in-a-row');
                                        answer2.addClass('animated tada three-in-a-row middle');
                                        answer3.addClass('animated tada three-in-a-row middle');
                                        answer4.addClass('animated tada three-in-a-row');
                                        setTimeout(() => {
                                            answer1.removeClass('animated tada three-in-a-row');
                                            answer2.removeClass('animated tada three-in-a-row middle');
                                            answer3.removeClass('animated tada three-in-a-row middle');
                                            answer4.removeClass('animated tada three-in-a-row');
                                        }, 1000);
                                    }
                                });
                            }

                            if ((threeInARow && !keepPlaying) || (keepPlaying && numberMatched === numberOfOptions)) {
                                self.pauseCurrentSound();
                                setTimeout(() => {
                                    if (
                                        me.activity_data.completion_text
                                        || me.activity_data.completion_title
                                        || me.activity_data.completion_audio
                                    ) {
                                        const modalActions = [];

                                        if (numberMatched < numberOfOptions) {
                                            modalActions.push({
                                                label: 'Keep Playing',
                                                cssClass: 'btn-xl btn-primary btn-continue',
                                                onClick(e) {
                                                    keepPlaying = true;
                                                    e.stopPropagation();
                                                    self.Popup.hideModal();
                                                },
                                            });
                                        }

                                        modalActions.push({
                                            label: 'Move On',
                                            cssClass: 'btn-xl btn-success btn-continue',
                                            onClick(e) {
                                                e.stopPropagation();
                                                self.Popup.hideModal();
                                            },
                                        });

                                        if (me.activity_data.completion_audio) {
                                            modalActions.push({
                                                label: 'Replay <i class="fa fa-volume-up"></i>',
                                                cssClass: 'btn-replay-audio btn-default pull-left',
                                                onClick(e) {
                                                    e.stopPropagation();
                                                    $(this).fadeOut();
                                                    self.playSound(me.activity_data.completion_audio, 0, null, () => {
                                                        $('#beep-9-modal .btn-replay-audio').fadeIn();
                                                    });
                                                },
                                            });
                                        }

                                        // show the completion-feedback modal window
                                        self.Popup.showModal({
                                            title: me.activity_data.completion_title,
                                            body: me.activity_data.completion_text,
                                            actions: modalActions,
                                            onShow() {
                                                me.setCompleted();
                                                // if there is an audio version of the text, play that file...
                                                $('#beep-9-modal .btn-replay-audio').hide();
                                                if (me.activity_data.completion_audio) {
                                                    if (
                                                        self.soundEnabled()
                                                        && !$(`#segment-${self.getCurrentSegmentIndex()}`).hasClass(
                                                            'dont-disable-help-continue',
                                                        )
                                                    ) {
                                                        $('#beep-9-modal .btn-continue').prop('disabled', true);
                                                    }
                                                    self.playSound(me.activity_data.completion_audio, 0, null, () => {
                                                        $('#beep-9-modal .btn-replay-audio').fadeIn();
                                                        $('#beep-9-modal .btn-continue').prop('disabled', false);
                                                        $(`#segment-${self.getCurrentSegmentIndex()}`).addClass(
                                                            'dont-disable-help-continue',
                                                        );
                                                    });
                                                }
                                            },
                                            onHide() {
                                                self.pauseCurrentSound();
                                                if (!keepPlaying || numberMatched === numberOfOptions) {
                                                    me.advance();
                                                } else {
                                                    setTimeout(() => {
                                                        // show the next clue
                                                        const $newClue = $('.bingo-clue:not(.matched)').first();
                                                        $newClue.addClass('active animated zoomInRight');
                                                        // set the new current_option_id
                                                        currentOptionId = $newClue.attr('data-option-id');
                                                        setTimeout(() => {
                                                            $newClue.removeClass('animated zoomInRight');
                                                            if ($newClue.hasClass('has-audio')) {
                                                                self.playSound($newClue.attr('data-audio'));
                                                            }
                                                        }, 500);
                                                    }, 500);
                                                }
                                            },
                                        });
                                    } else {
                                        me.setCompleted();
                                        self.Popup.hideModal();
                                        if (!keepPlaying || numberMatched === numberOfOptions) {
                                            me.advance();
                                        } else {
                                            setTimeout(() => {
                                                // show the next clue
                                                const $newClue = $('.bingo-clue:not(.matched)').first();
                                                $newClue.addClass('active animated zoomInRight');
                                                // set the new current_option_id
                                                currentOptionId = $newClue.attr('data-option-id');
                                                setTimeout(() => {
                                                    $newClue.removeClass('animated zoomInRight');
                                                    if ($newClue.hasClass('has-audio')) {
                                                        self.playSound($newClue.attr('data-audio'));
                                                    }
                                                }, 500);
                                            }, 500);
                                        }
                                    }
                                }, 750);
                            } else {
                                setTimeout(() => {
                                    // show the next clue
                                    const $newClue = $('.bingo-clue:not(.matched)').first();
                                    $newClue.addClass('active animated zoomInRight');
                                    // set the new current_option_id
                                    currentOptionId = $newClue.attr('data-option-id');
                                    setTimeout(() => {
                                        $newClue.removeClass('animated zoomInRight');
                                        if ($newClue.hasClass('has-audio')) {
                                            self.playSound($newClue.attr('data-audio'));
                                        }
                                    }, 500);
                                }, 500);
                            }
                        } else {
                            self.playSoundEffect('incorrect');
                            $answer.addClass('incorrect');
                            $(`.bingo-clue[data-option-id="${currentOptionId}"]`).addClass('animated shake');
                            setTimeout(() => {
                                $(`.bingo-clue[data-option-id="${currentOptionId}"]`).removeClass('animated shake');
                                $answer.removeClass('incorrect');
                            }, 500);
                        }
                    });

                    // randomize order of items (if shuffled == 1)
                    if (+me.activity_data.shuffled === 1 && Math.floor(Math.random() * 2)) {
                        bingoBoard.append(bingoAnswer);
                    } else {
                        bingoBoard.prepend(bingoAnswer);
                    }

                    const bingoClue = $('<div></div>').addClass('bingo-clue');
                    bingoClue.attr('data-option-id', option.activity_option_id);
                    bingoClue.attr('data-index', index);

                    const clueWrapper = $('<div></div>').addClass('wrapper');
                    if (option.hint_image) {
                        bingoClue.addClass('has-image');
                        clueWrapper.append(
                            `<div class="option-image-container"><img src="${option.hint_image}" class="img-responsive option-image" /></div>`,
                        );
                    } else {
                        bingoClue.addClass('text-only');
                    }

                    if (option.hint_audio) {
                        bingoClue.addClass('has-audio');
                        bingoClue.attr('data-audio', option.hint_audio);
                    }

                    if (option.hint) {
                        clueWrapper.append(`<div><span>${option.hint}</span></div>`);
                    }

                    bingoClue.append(clueWrapper);

                    // randomize order of items (if shuffled == 1)
                    if (+me.activity_data.shuffled === 1 && Math.floor(Math.random() * 2)) {
                        clues.append(bingoClue);
                    } else {
                        clues.prepend(bingoClue);
                    }

                    index++;
                });

                cluesContainer.append(clues);
                segmentContainer.append(bingoBoard);
                segmentContainer.append(cluesContainer);

                container.find('.aspect-wrapper').append(segmentContainer);

                // add this segment container to the page
                $('#page-container').append(container);

                for (let i = 1; i <= 9; i++) {
                    answerIds[parseInt($(`.bingo-board > .bingo-answer:nth-child(${i})`).attr('data-index'), 10)] = i;
                }
            };

            me.replay = function (forceShowHelp = false) {
                numberMatched = 0;

                $(container)
                    .find('.bingo-answer')
                    .each(function () {
                        $(this).removeClass('correct incorrect');
                    });

                $(container).find('.bingo-clue').removeClass('active matched animated shake zoomOutLeft zoomInRight');

                self.Popup.showHelp(
                    me,
                    () => {
                        $(container).find('.bingo-clue').first().addClass('active animated zoomInRight');
                        currentOptionId = $('.bingo-clue.active').attr('data-option-id');
                        setTimeout(() => {
                            $('.bingo-clue.active').removeClass('animated zoomInRight');
                            if ($('.bingo-clue.active').hasClass('has-audio')) {
                                self.playSound($('.bingo-clue.active').attr('data-audio'));
                            }
                        }, 500);

                        if (me.completed && !me.last) {
                            self.showNextButton();
                        }
                    },
                    forceShowHelp,
                );
            };

            me.show = function () {
                me.setup();
                me.replay();
            };

            me.hide = function () {
                me.breakdown();
            };

            return me;
        };

        return self;
    }(my.Lesson || {}));

    return my;
}(Postlogin || {}));
